<template>
  <div :class="['h-[1px] w-full my-2 bg-grey-light-200', props.className]" />
</template>

<script setup lang="ts">
const props = defineProps<{
  className?: string;
}>();
</script>
